import { request } from './index';
import { getExamResultsQueryKey } from '../hooks/react-query/use-exam-result';
import { LessonType } from './lesson';

export type ExamResultType = {
  id: number;
  lesson: LessonType;
  correctQuestionCount: number;
  wrongQuestionCount: number;
  questionCount: number;
  score: number;
  rank: number | null;
  standardScore: number | null;
  scaledScore: number | null;
};

export async function fetchExamResults({
  queryKey: [_, { examId }]
}: {
  queryKey: ReturnType<typeof getExamResultsQueryKey>;
}): Promise<ExamResultType[]> {
  return await request(true, { url: `/students/exam-results/e-${examId}` });
}
